<template>
  <div class="coupon">
    <van-nav-bar
      title="会员权益"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div v-if='$store.state.shopid==27' >
      <img
        src="../../assets/cvip.jpg"
        alt=""
      >
    </div>
    <div v-else >
      <img
        src="../../assets/membervip.jpeg"
        alt=""
      >
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar } from 'vant';

Vue.use(NavBar)
export default {
  data () {
    return {
      active: 0,
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
</style>